/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sum',
    pure: false,
})
export class SumPipe implements PipeTransform {
  transform(array: any[], property: string): number {
    if (!array || !property) {
      return 0;
    }

    return array.reduce((sum, item) => {
      const nestedProperties = property.split('.');
      const nestedValue = nestedProperties.reduce(
        (value, prop) => value?.[prop],
        item,
      );
      return sum + (typeof nestedValue === 'number' ? nestedValue : 0);
    }, 0);
  }
}
